import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

import { computed, onMounted, ref } from "vue"
  import { useNewsFeedStore } from "@/store/newsfeed"
  import { IonList } from "@ionic/vue"
  import router from "@/router"

  // component
  import ThoughtLeadershipContainer from "@/components/workbean-page/home/ThoughtLeadership.vue"
  import EmployeeAmbassadorshipContainer from "@/components/workbean-page/home/EmployeeAmbassadorship.vue"
  import PostTemplate from "@/components/template/PostTemplate.vue"
  import Insights from "@/components/world-feed/InsightContainer.vue"

  
export default /*#__PURE__*/_defineComponent({
  __name: 'PostsContainer',
  setup(__props) {

  const newsfeedStore = useNewsFeedStore()

  const feedList = computed(() => newsfeedStore.newsfeedList)

  /***
   * Retrieves additional feed from backend and merges to the current list
   */
  const initialize = async () => {
    newsfeedStore.newsfeedList = []
    await newsfeedStore.retrieveFeed({ user: `${router.currentRoute.value.params.user}` })
  }

  onMounted(() => {
    initialize()
  })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonList), {
    lines: "none",
    class: "pb-20"
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(feedList), (feed, index) => {
        return (_openBlock(), _createBlock(PostTemplate, {
          key: `${index}_feed`,
          "post-data": feed,
          "post-page-location": "world",
          class: "mb-10"
        }, {
          default: _withCtx(() => [
            (!feed.answer_content && feed.content.html)
              ? (_openBlock(), _createBlock(Insights, {
                  key: 0,
                  id: feed.newsfeed_id,
                  "html-link": feed.content.html
                }, null, 8, ["id", "html-link"]))
              : (feed.answer_content && feed.answer_content.answer && feed.answer_content.answer.answers && feed.answer_content.answer.answers.length > 0)
                ? (_openBlock(), _createBlock(EmployeeAmbassadorshipContainer, {
                    key: 1,
                    "user-answers": feed.answer_content,
                    likes: feed.likes,
                    shares: feed.shares,
                    post_id: feed.newsfeed_id
                  }, null, 8, ["user-answers", "likes", "shares", "post_id"]))
                : (feed.answer_content && feed.answer_content.answer && feed.answer_content.answer.answer)
                  ? (_openBlock(), _createBlock(ThoughtLeadershipContainer, {
                      key: 2,
                      "post-id": feed.newsfeed_id,
                      user: feed.answer_content.user,
                      answer: feed.answer_content.answer,
                      company: feed.answer_content.company
                    }, null, 8, ["post-id", "user", "answer", "company"]))
                  : _createCommentVNode("", true)
          ]),
          _: 2
        }, 1032, ["post-data"]))
      }), 128))
    ]),
    _: 1
  }))
}
}

})